import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * @param {ParentNode} root
 * @param {string | undefined} blockId
 * @returns {Element | null}
 */
function findDeliveryTimeInDocument(root, blockId) {
  if (blockId) {
    const candidates = root.querySelectorAll('ace-delivery-time');
    const match = Array.from(candidates).find((el) => el instanceof HTMLElement && el.dataset.blockId === blockId);
    if (match) return match;
  }
  return root.querySelector('ace-delivery-time');
}

/**
 * Delivery-time line sourced from the `custom.lieferzeit` metafield. Re-renders on
 * variant change so the line hides for unavailable variants and reappears for
 * available ones. Mirrors the morph pattern of `product-inventory.js`.
 */
class AceDeliveryTime extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDeliveryTime);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDeliveryTime);
  }

  /**
   * Updates the delivery-time line.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateDeliveryTime = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const doc = event.detail?.data?.html;
    if (!doc || typeof doc.querySelector !== 'function') return;

    const blockId = this.dataset.blockId;
    const newDeliveryTime = findDeliveryTimeInDocument(doc, blockId);

    if (!newDeliveryTime) return;

    morph(this, newDeliveryTime, { childrenOnly: true });
  };
}

if (!customElements.get('ace-delivery-time')) {
  customElements.define('ace-delivery-time', AceDeliveryTime);
}
